<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Safras from '@/components(new)/UI/Forms/FormulariosProntos/Safras/Safras.vue'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import CulturaProdutividade from '@/components(new)/UI/Forms/FormulariosProntos/CulturaProdutividade/CulturaProdutividade.vue'
import { tipoCoberturaVegetal } from '@/libs/constants/praticas/opcoesSelects'
import { irrigacao } from '@/libs/models/cadastro/praticas/genericos'
import { formataStringYearMonthToBr } from '@/libs/utils/functions/dataFormater'
import { safrasValidation, bioinsumosValidation, irrigacaoValidation, financiamentosValidation } from '@/libs/utils/validations/praticasValidations'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    Label,
    InputSelect,
    Safras,
    Card,
    Bioinsumos,
    Financiamentos,
    Irrigacao,
    CulturaProdutividade
  },
  props: {
    pratica: {
      type: Array,
      required: true
    },
    observer: {
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Práticas',
      tipoCoberturaVegetal,
      isEdit: false,
      forms: {
        ano: '',
        areaDestinada: '',
        dataInicio: '',
        hasRotacaoCulturas: '',
        atividadesAgricolaProdutividade: [],
        coberturasVegetais: [],
        outrosCoberturaVegetal: '',
        possuiIrrigacao: '',
        irrigacao: {...irrigacao},
        utilizaBioinsumos: '',
        bioinsumos: [],
        financiamentos: [],
        outroFinanciamento: '',
        descricao: '',
        id: uuidv4()
      }
    }
  },
  computed: {
    // valida todos cadastros para cadastrar mais um card
    validationDisableButton () {
      const forms = this.forms
      return safrasValidation(forms.ano, forms.areaDestinada, forms.dataInicio) ||
      this.culturasValidation(forms.hasRotacaoCulturas, forms.atividadesAgricolaProdutividade, forms.coberturasVegetais, forms.outrosCoberturaVegetal) ||
      bioinsumosValidation(forms.utilizaBioinsumos, forms.bioinsumos) ||
      irrigacaoValidation(forms.possuiIrrigacao, forms.irrigacao) ||
      financiamentosValidation(forms.financiamentos, forms.outroFinanciamento)
    },
    rules () {
      return !this.pratica.length ? 'required' : ''
    }
  },
  methods: {
    btnAdicionar () {
      this.isEdit = false
      this.pratica.push(this.forms)
      this.forms = {
        ano: '',
        areaDestinada: '',
        dataInicio: '',
        hasRotacaoCulturas: '',
        atividadesAgricolaProdutividade: [],
        coberturasVegetais: [],
        outrosCoberturaVegetal: '',
        possuiIrrigacao: '',
        irrigacao: {...irrigacao},
        utilizaBioinsumos: '',
        bioinsumos: [],
        financiamentos: [],
        outroFinanciamento: '',
        descricao: '',
        id: uuidv4()
      }
    },
    editarPratica (pratica, index) {
      this.forms = pratica
      this.isEdit = true
      this.pratica.splice(index, 1)
    },
    removerPratica (index) {
      this.pratica.splice(index, 1)
    },
    culturasValidation (possuiRotacaoCulturas, atividadesAgricolaProdutividade, coberturasVegetais, outrosCoberturaVegetal) {
      const naoSelecionouRotacaoCulturas = possuiRotacaoCulturas === ''
      const usaRotacaoCulturas = possuiRotacaoCulturas === true
      const atividadesAgricolaInvalidos = !Array.isArray(atividadesAgricolaProdutividade) || atividadesAgricolaProdutividade.length === 0
      const tiposCoberturas = !Array.isArray(coberturasVegetais) || coberturasVegetais.length === 0 ||
      (coberturasVegetais.includes('OUTRA') && (!outrosCoberturaVegetal || outrosCoberturaVegetal.trim() === ''))
      return naoSelecionouRotacaoCulturas || tiposCoberturas || (usaRotacaoCulturas && (atividadesAgricolaInvalidos))
    },
    containsOption (parent, option, model) {
      if (!parent || !parent.length) return
      let contains

      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }

      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica[this.indexForms])
        if (target && lastProp) {
          target[lastProp] = ''
        }
      }
      return contains
    },
    safrasValidation,
    formataStringYearMonthToBr,
    bioinsumosValidation,
    irrigacaoValidation,
    financiamentosValidation
  }
}
</script>

<template>
  <div>
    <!-- Formulários -->
    <Safras
      :nomeAba="nomeAba"
      :anoSafra.sync="forms.ano"
      :areaDestinada.sync="forms.areaDestinada"
      :dataInicio.sync="forms.dataInicio"
      :praticasArray="pratica"
    />

    <el-row>
      <InputSelect
        label="Há rotação de culturas?"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="[
          {id: true, nome: 'Sim'},
          {id: false, nome: 'Não'}
        ]"
        :widthColumn="8"
        v-model="forms.hasRotacaoCulturas"
      />
    </el-row>

    <CulturaProdutividade
      v-if="forms.hasRotacaoCulturas"
      :nomeAba="nomeAba"
      :culturasProdutividade="forms.atividadesAgricolaProdutividade"
    />

    <el-row :gutter="20">
      <InputSelect
        label="Tipo de cobertura vegetal:"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="tipoCoberturaVegetal"
        :widthColumn="8"
        :multi-select="true"
        v-model="forms.coberturasVegetais"
      />
      <el-col :span="8" v-if="containsOption(forms.coberturasVegetais, 'OUTRA', 'outrosCoberturaVegetal')">
        <validation-provider
          :rules="'required'"
          v-slot="{ errors }"
          mode="lazy"
          :name="`${nomeAba}/Outro/qual`"
        >
          <Label
            label="Outro/qual"
            :obrigatorio="true"
          />
          <el-input
            name="Outro/qual"
            v-model="forms.outrosCoberturaVegetal"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </validation-provider>
      </el-col>
    </el-row>

    <Bioinsumos
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <Irrigacao
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <Financiamentos
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <el-row>
      <validation-provider>
        <el-col :span="23">
          <Label label="Descrição" :obrigatorio="false" />
          <el-input
            name="Descrição" v-model="forms.descricao"
            class="input" type="textarea"
            maxlength="500"
            show-word-limit
          />
        </el-col>
      </validation-provider>
    </el-row>

    <!-- Botão de adicionar e card-->
    <div class="flex-end mt-3 mb-3">
      <el-button :disabled="validationDisableButton" round type="primary" @click="btnAdicionar">
         {{ isEdit ? 'Salvar' : 'Adicionar'}} Ano/Safra
      </el-button>
    </div>

    <el-row :gutter="20">
      <div class="flex-wrapper row">
        <Card
          v-for="(item, index) in pratica"
          :key="index"
          :objeto="{
            ano: item.ano,
            areaDestinada: item.areaDestinada + ' ha',
            dataInicio: formataStringYearMonthToBr(item.dataInicio)
          }"
          :titulo="`Ano safra: ${item.ano || ''}`"
          :deletar="() => removerPratica(index)"
          :editar="() => editarPratica(item, index)"
        />
      </div>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDH/SPDH.vue